import { useState } from 'react';

import {
  ActionBar,
  ChakraBox,
  FAIconName,
  useToastMessage,
} from '@equip.health/ui';

import { capitalizeFirstLetter } from '~/lib/common';
import { useResendInvitationMutation } from '~/store/services/patients';

const ResendInvitation = ({
  isProvider,
  isSupport,
  name,
  userId,
}: {
  isProvider?: boolean;
  isSupport?: boolean;
  name: string;
  userId: string;
}) => {
  const [isInvitationSent, setInvitationSent] = useState<boolean>(false);
  const { createToast } = useToastMessage();

  const [resendInvitation] = useResendInvitationMutation();

  const onResendInvitation = () => {
    if (isInvitationSent) return;
    resendInvitation({ isProvider, isSupport, userId })
      .unwrap()
      .then(() => {
        setInvitationSent(true);
        createToast({
          icon: FAIconName.checkRegular,
          id: 'resend-mail-success_toast',
          text: 'Email resent',
          variant: 'success',
        });
      })
      .catch(() => {
        createToast({
          icon: FAIconName.exclamationTriangleRegular,
          id: 'resend-mail-error_toast',
          text: "We're sorry, we were unable to resend email at this time. Please try again.",
          variant: 'critical',
        });
      });
  };

  return (
    <ChakraBox marginTop="18px">
      {!isInvitationSent && (
        <ActionBar
          barIcon={FAIconName.exclamationTriangleRegular}
          buttonIcon={FAIconName.redoRegular}
          buttonText="Resend password creation email"
          id="resend-invitation"
          onButtonClick={onResendInvitation}
          text={`${capitalizeFirstLetter(name)} has not created an account password yet`}
          variant="warning"
        />
      )}
    </ChakraBox>
  );
};

export default ResendInvitation;
